import './App.css'
import { InstagramOutlined, TwitterOutlined } from "@ant-design/icons"
import WrapperMediaPlayer from './WrapperMediaPlayer';


function App() {
    // <MediaPlayer />
    return (
        <div className="App">
            <div>
                <img src={"/logo.jpg"} className="logo" alt="Vite logo" />
            </div>

            <div><WrapperMediaPlayer /></div>

            <h1 style={{ fontSize: "24px" }}>Suivez nous sur Twitter & Instagram</h1>
            <a href={"https://twitter.com/MaisonduQuran"}>
                <TwitterOutlined style={{ fontSize: '4em' }} alt={"twitter"} />
            </a>
            <a href={"https://www.instagram.com/maison_du_quran/"}>
                <InstagramOutlined style={{ fontSize: '4em' }} alt={"instagram"} />
            </a>
            <div>

            </div>

            <div style={{ fontSize: "12px", marginTop: "50px" }}>&copy; Copyright {new Date().getFullYear()} Maison du
                Quran. All Rights Reserved
            </div>

        </div >
    )
}

export default App
